module.exports = __webpack_public_path__ + "img/75630.37681bef.svg";